import { graphql } from '../../../../../../gql'

export const WhatsAppConnectionInfo = graphql(/* GraphQL */ `
  query WhatsAppConnectionInfo($input: WhatsAppConnectionInfoInput!) {
    whatsAppConnectionInfo(input: $input) {
      __typename
      ... on WhatsAppConnectionInfoResponse {
        metaAppId
        embeddedSignupConfigId
        graphApiVersion
      }
      ... on InvalidInputError {
        message
      }
      ... on NotFoundError {
        message
      }
      ... on LimitReachedError {
        message
      }
    }
  }
`)
